import { AnimalBase, Trait } from 'api/query/shared';
import {
  Exclude, Expose, Transform, Type
} from 'class-transformer';
import { Sex } from 'shared/sex.enum';
import { getSexDesc } from 'utils/utils';
import { PedigreeVisibility } from '../shared/pedigree-visibility-enum';
import { parseAddress, parseBreeder, parsePhone } from './animal-utils';

@Exclude()
export class Animal implements AnimalBase {
  @Expose()
  animalId: string;

  @Expose()
  studId: string;

  @Expose()
  damAnimalId: string;

  @Expose()
  damVisibility: PedigreeVisibility;

  @Expose()
  sireAnimalId: string;

  @Expose()
  sireVisibility: PedigreeVisibility;

  @Expose()
  isMss: boolean;

  @Expose()
  isDna: boolean;

  @Expose()
  semenAvailable: boolean;

  @Expose()
  forSale: boolean;

  @Expose()
  sireInRefFlock: boolean;

  @Expose()
  sireInCpt: boolean;

  @Expose()
  isRegistered: boolean;

  @Expose()
  isMlp: boolean;

  @Expose()
  @Type(() => Trait)
  asbvs: Trait[];

  @Expose()
  searchKey: string;

  @Expose()
  @Type(() => Trait)
  indexes: Trait[];

  @Expose()
  displayedId: string;

  @Expose()
  progenyNum: number;

  @Expose()
  flockNum: number;

  @Expose()
  studName: string

  @Expose()
  sex: Sex;

  @Expose()
  @Transform((value, obj) => getSexDesc(obj.sex))
  sexDesc: string;

  @Expose()
  breed: string;

  @Expose()
  drop: number;

  @Expose()
  addressLine: string;

  @Expose()
  state: string;

  @Expose()
  postcode: number;

  @Expose()
  @Transform((value, obj) => parseAddress(obj))
  address: string;

  @Expose()
  breederName: string;

  @Expose()
  breedFlockCode: number

  @Expose()
  @Transform((value, obj) => parseBreeder(obj))
  breeder: string;

  @Expose()
  @Transform((value, obj) => parsePhone(obj))
  phone: string;

  @Expose()
  website: string;
}
